import React, { useEffect, useState } from 'react';
import {
    Box,
    Checkbox,
    FormControlLabel,
    Grid,
    Typography,
} from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import StepperButtons from '../../../components/general/stepper/stepperButtons';
import { IParam } from '../../../../shared/types/param';
import { asyncGetChannels } from '../../../../services/params.service';
import AutoCompleteField from '../../../components/general/fields/autoCompleteField';
import FieldText from '../../../components/general/fields/fieldText';
import FieldSelect from '../../../components/general/fields/fieldSelect';
import { types } from '../../../../redux/types';
import { useDispatch } from 'react-redux';
import { asyncPostTipificationCosmos } from '../../../../services/caseReport.service';
import { SwalCustomClass } from '../../../components/general/toastSwal/swalCustomClass';
import { MasterMessage } from '../../../../masters/masterMessages';
import { asyncCitiesByText } from '../../../../services/general.service';

type Props = {
    stepsLength: number;
    globalTypifications: any[];
    infoContact: any;
    identifications: any[];
    onNumberCase: (value: any) => void;
    userLog: string;
    nameLog: string;
    surnameLog: string;
    usernameLog: string;
    globalId: string;
    onFormikTouchedGlobalId: (value: boolean | undefined) => void;
    onFormikErrorsGlobalId: (value: string | undefined) => void;
    onFormikValueGlobalId: (value: string | undefined) => void;
    onFormikReset: (value: boolean) => void;
};

const Typification = ({
    stepsLength,
    globalTypifications,
    infoContact,
    identifications,
    onNumberCase,
    userLog,
    nameLog,
    surnameLog,
    usernameLog,
    globalId,
    onFormikTouchedGlobalId,
    onFormikErrorsGlobalId,
    onFormikValueGlobalId,
    onFormikReset,
}: Props) => {
    const dispatch: any = useDispatch();
    const { messageErrorTipification } = MasterMessage.caseReport;
    const [channels, setChannels] = useState<IParam[]>([]);
    const [blurSubRequest, setBlurSubRequest] = useState<string>('');
    const [requestTypes, setRequestTypes] = useState<IParam[]>([]);
    const [blurRequestType, setBlurRequestType] = useState<string>('');
    const [processTypes, setProcessTypes] = useState<IParam[]>([]);
    const [blurProcessType, setBlurProcessType] = useState<string>('');
    const [typifications, setTypifications] = useState<IParam[]>([]);
    const [blurTypifications, setBlurTypifications] = useState<string>('');
    const [subTypifications, setSubTypifications] = useState<IParam[]>([]);
    const [blurSubTypifications, setBlurSubTypifications] =
        useState<string>('');
    const [subTypificationsChild, setSubTypificationsChild] = useState<
        IParam[]
    >([]);
    const [submit, setSubmit] = useState<boolean>(false);
    const [cities, setCities] = useState<
        { id: number; name: string; department: object }[]
    >([]);
    const [searchCityName, setSearchCityName] = useState<any>(undefined);
    const [department, setDepartment] = useState<any>(undefined);
    const [duplicated, setDuplicated] = useState<boolean>(false);
    const [maintain, setMaintain] = useState<boolean>(false);

    const validateTypeId = (typeId: any) => {
        return (
            identifications.filter((row) => row.id === typeId)[0]?.value || ''
        );
    };

    const formik = useFormik({
        initialValues: {
            typeId: validateTypeId(infoContact?.typeId) || '',
            numberId: infoContact?.numberId || '',
            channelTypeId: '',
            subRequest: '',
            requestTypeId: '',
            processId: '',
            typificationId: '',
            subTypificationId: '',
            subTypificationChildId: '',
            staggering: '',
            description: '',
            cityId: '',
            departmentId: '',
            createdBy: userLog,
            isPotential: '',
            globalId: '',
            validate: true,
            documentAuthorized: '',
            supervisorAuthorized: '',
        },
        validationSchema: Yup.object({
            globalId: Yup.string()
                .required('El global id es obligatorio')
                .matches(
                    /^[A-Za-z0-9]{8}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{12}$/,
                    'Formato invalido'
                ),
            channelTypeId: Yup.string().required(
                'El tipo de canal es obligatorio'
            ),
            subRequest: Yup.string().required(
                'El sub solicitud es obligatoria'
            ),
            requestTypeId: Yup.string().required(
                'El tipo solicitud es obligatoria'
            ),
            processId: Yup.string().required('El proceso es obligatorio'),
            typificationId: Yup.string().required(
                'La tipificación es obligatorio'
            ),
            subTypificationId: Yup.string().required(
                'La subtipificación es obligatorio'
            ),
            staggering: Yup.string().required(
                'El requiere escalamiento es obligatorio'
            ),
            description: Yup.string().required('La descripción es obligatoria'),
            documentAuthorized: Yup.string().when(['validate'], {
                is: (validate: any) => !validate,
                then: (schema) =>
                    schema.required('El documento del asesor es obligatorio'),
            }),
            supervisorAuthorized: Yup.string().when(['validate'], {
                is: (validate: any) => !validate,
                then: (schema) =>
                    schema.required('El nombre del supervisor es obligatorio'),
            }),
        }),
        onSubmit: (formTypification) => {
            setSubmit(true);
            if (formTypification.isPotential !== null) {
                formTypification.isPotential = String(
                    formTypification.isPotential
                );
            }
            asyncPostTipificationCosmos(formTypification)
                .then((body: any) => {
                    if (body?.items !== undefined) {
                        if (body?.items?.mensaje === 'Exist typifaction') {
                            setDuplicated(true);
                        } else {
                            onNumberCase(body?.items.case);
                            onFormikReset(true);
                            dispatch({ type: types.nextStepper });
                        }
                    } else {
                        SwalCustomClass.fire({
                            text: messageErrorTipification,
                            icon: 'error',
                            iconColor: '#1d1d1d',
                        });
                    }
                })
                .finally(() => setSubmit(false))
                .catch(() => setSubmit(false));
        },
    });

    useEffect(() => {
        formik.setFieldValue('globalId', globalId);
        onFormikTouchedGlobalId(formik.touched.globalId);
        onFormikErrorsGlobalId(formik.errors.globalId);
        onFormikValueGlobalId(formik.values.globalId);

        if (searchCityName) {
            searchCity(searchCityName.toUpperCase());
        }

        if (channels.length === 0) {
            asyncGetChannels().then((body: any) => {
                if (body.length > 0) {
                    setChannels(body);
                }
            });
        }

        if (formik.values.subTypificationId !== '') {
            if (blurSubTypifications !== formik.values.subTypificationId) {
                formik.values.subTypificationChildId = '';
            }
            const rowSubTypificationsChild =
                globalTypifications.filter(
                    (item) => item.parentId === formik.values.subTypificationId
                ) || [];
            setSubTypificationsChild(rowSubTypificationsChild);
        } else {
            formik.values.subTypificationChildId = '';
            setSubTypificationsChild([]);
        }

        if (formik.values.typificationId !== '') {
            if (blurTypifications !== formik.values.typificationId) {
                formik.values.subTypificationId = '';
            }
            const rowSubTypifications =
                globalTypifications.filter(
                    (item) => item.parentId === formik.values.typificationId
                ) || [];
            setSubTypifications(rowSubTypifications);
        } else {
            formik.values.subTypificationId = '';
        }

        if (formik.values.processId !== '') {
            if (blurProcessType !== formik.values.processId) {
                formik.values.typificationId = '';
            }
            const rowTypifications =
                globalTypifications.filter(
                    (item) => item.parentId === formik.values.processId
                ) || [];
            setTypifications(rowTypifications);
        } else {
            formik.values.typificationId = '';
        }

        if (formik.values.requestTypeId !== '') {
            if (blurRequestType !== formik.values.requestTypeId) {
                formik.values.processId = '';
            }
            const rowProcess =
                globalTypifications.filter(
                    (item) =>
                        item.parentId === formik.values.requestTypeId &&
                        item.type === formik.values.subRequest
                ) || [];
            setProcessTypes(rowProcess);
        } else {
            formik.values.processId = '';
        }

        if (formik.values.subRequest !== '') {
            if (blurSubRequest !== formik.values.subRequest) {
                formik.values.processId = '';
            }
            const rowsubRequest =
                globalTypifications.filter((item) => item.parentId === null) ||
                [];
            setRequestTypes(rowsubRequest);
        }
    }, [
        channels,
        searchCityName,
        globalTypifications,
        formik.values.subRequest,
        formik.values.requestTypeId,
        formik.values.processId,
        formik.values.typificationId,
        formik.values.subTypificationId,
        globalId,
        formik.touched.globalId,
        formik.errors.globalId,
        formik.values.globalId,
    ]);

    const searchCity = (value: any) => {
        if (value.length === 1 || value.length === 3 || value.length === 5) {
            asyncCitiesByText(value.toUpperCase()).then((body: any) => {
                if (body?.length) setCities(body);
            });
        }
    };

    const validateCity = (value: any) => {
        formik.values.cityId = value;
        if (value) {
            const data = cities?.find((c) => c.id === value) || undefined;
            if (data !== undefined) {
                setDepartment(data.department);
                const row: any = data.department;
                formik.values.departmentId = row.id;
            }
        } else {
            formik.values.departmentId = '';
            setDepartment(undefined);
        }
    };

    const maintainTypificacion = () => {
        setDuplicated(false);
        setMaintain(true);
        formik.values.validate = false;
    };

    const closeMaintain = () => {
        setDuplicated(false);
        setMaintain(false);
        formik.values.validate = true;
    };

    const optionsRequest = [
        {
            id: 'B',
            name: 'Beneficiario',
        },
        {
            id: 'C',
            name: 'Ciudadano',
        },
    ];

    const optionsEscalation = [
        {
            id: 1,
            name: 'Si',
        },
        {
            id: 0,
            name: 'No',
        },
    ];

    return (
        <>
            {!duplicated && !maintain ? (
                <>
                    <Box>
                        <Grid
                            container
                            spacing={{ xs: 1.5, md: 1.5 }}
                            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                        >
                            <Grid item xs={12} md={6} lg={6}>
                                <AutoCompleteField
                                    data={channels}
                                    label="Tipo de canal"
                                    name="channelTypeId"
                                    size="small"
                                    required={true}
                                    touched={formik.touched.channelTypeId}
                                    errors={formik.errors.channelTypeId}
                                    value={formik.values.channelTypeId}
                                    onChangeValue={(value) =>
                                        formik.setFieldValue(
                                            'channelTypeId',
                                            value
                                        )
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                                <FieldSelect
                                    data={optionsRequest}
                                    label="Sub Solicitud"
                                    name="subRequest"
                                    size="small"
                                    required={true}
                                    touched={formik.touched.subRequest}
                                    errors={formik.errors.subRequest}
                                    value={formik.values.subRequest}
                                    onChange={formik.handleChange}
                                    onBlur={(e) =>
                                        setBlurSubRequest(e.target.value)
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                                <AutoCompleteField
                                    data={cities}
                                    label="Ciudad"
                                    name="cityId"
                                    size="small"
                                    required={true}
                                    touched={formik.touched.cityId}
                                    errors={formik.errors.cityId}
                                    value={formik.values.cityId}
                                    onChangeValue={(value) =>
                                        validateCity(value)
                                    }
                                    inputValueEnabled={true}
                                    onInputValue={(value: any) =>
                                        setSearchCityName(value)
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                                <FieldText
                                    label="Departamento"
                                    name="departmentId"
                                    size="small"
                                    required={true}
                                    disabled
                                    value={department?.name || ''}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                                <AutoCompleteField
                                    data={requestTypes}
                                    label="Tipo Solicitud"
                                    name="requestTypeId"
                                    size="small"
                                    required={true}
                                    disabled={Boolean(
                                        formik.values.subRequest === ''
                                    )}
                                    touched={formik.touched.requestTypeId}
                                    errors={formik.errors.requestTypeId}
                                    value={formik.values.requestTypeId}
                                    getOptionLabel={(option: any) =>
                                        option.description || ''
                                    }
                                    onChangeValue={(value) =>
                                        formik.setFieldValue(
                                            'requestTypeId',
                                            value
                                        )
                                    }
                                    onBlur={(e) =>
                                        setBlurRequestType(e.target.id)
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                                <AutoCompleteField
                                    data={processTypes}
                                    label="Proceso"
                                    name="processId"
                                    size="small"
                                    required={true}
                                    disabled={Boolean(
                                        formik.values.requestTypeId === ''
                                    )}
                                    touched={formik.touched.processId}
                                    errors={formik.errors.processId}
                                    value={formik.values.processId}
                                    getOptionValue={
                                        parseInt(
                                            formik.values.requestTypeId
                                        ) === 2
                                    }
                                    getOptionLabel={(option: any) =>
                                        option &&
                                        parseInt(
                                            formik.values.requestTypeId
                                        ) === 2
                                            ? option.id +
                                              ' ' +
                                              option.description
                                            : option.description || ''
                                    }
                                    onChangeValue={(value) =>
                                        formik.setFieldValue('processId', value)
                                    }
                                    onBlur={(e) =>
                                        setBlurProcessType(e.target.id)
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                                <AutoCompleteField
                                    data={typifications}
                                    label="Tipificación"
                                    name="typificationId"
                                    size="small"
                                    required={true}
                                    disabled={Boolean(
                                        formik.values.processId === ''
                                    )}
                                    touched={formik.touched.typificationId}
                                    errors={formik.errors.typificationId}
                                    value={formik.values.typificationId}
                                    getOptionLabel={(option: any) =>
                                        option.description || ''
                                    }
                                    onChangeValue={(value) =>
                                        formik.setFieldValue(
                                            'typificationId',
                                            value
                                        )
                                    }
                                    onBlur={(e) =>
                                        setBlurTypifications(e.target.id)
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                                <AutoCompleteField
                                    data={subTypifications}
                                    label="Subtipificación"
                                    name="subTypificationId"
                                    size="small"
                                    required={true}
                                    disabled={Boolean(
                                        formik.values.typificationId === ''
                                    )}
                                    touched={formik.touched.subTypificationId}
                                    errors={formik.errors.subTypificationId}
                                    value={formik.values.subTypificationId}
                                    getOptionLabel={(option: any) =>
                                        option.description || ''
                                    }
                                    onChangeValue={(value) =>
                                        formik.setFieldValue(
                                            'subTypificationId',
                                            value
                                        )
                                    }
                                    onBlur={(e) =>
                                        setBlurSubTypifications(e.target.id)
                                    }
                                />
                            </Grid>
                            {subTypificationsChild?.length > 0 && (
                                <Grid item xs={12} md={6} lg={6}>
                                    <AutoCompleteField
                                        data={subTypificationsChild}
                                        label="Subtipificación Hija"
                                        name="subTypificationChildId"
                                        size="small"
                                        disabled={Boolean(
                                            formik.values.subTypificationId ===
                                                ''
                                        )}
                                        touched={
                                            formik.touched
                                                .subTypificationChildId
                                        }
                                        errors={
                                            formik.errors.subTypificationChildId
                                        }
                                        value={
                                            formik.values.subTypificationChildId
                                        }
                                        getOptionLabel={(option: any) =>
                                            option.description || ''
                                        }
                                        onChangeValue={(value) =>
                                            formik.setFieldValue(
                                                'subTypificationChildId',
                                                value
                                            )
                                        }
                                    />
                                </Grid>
                            )}
                            <Grid item xs={12} md={6} lg={6}>
                                <FieldSelect
                                    data={optionsEscalation}
                                    label="Requiere Escalonamiento"
                                    name="staggering"
                                    size="small"
                                    required={true}
                                    touched={formik.touched.staggering}
                                    errors={formik.errors.staggering}
                                    value={formik.values.staggering}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={subTypificationsChild?.length > 0 ? 12 : 6}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <FormControlLabel
                                    control={<Checkbox />}
                                    label="¿Es potencial?"
                                    id="checkbox"
                                    name="isPotential"
                                    checked={Boolean(formik.values.isPotential)}
                                    value={formik.values.isPotential}
                                    onChange={() =>
                                        formik.setFieldValue(
                                            'isPotential',
                                            !formik.values.isPotential
                                        )
                                    }
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FieldText
                                    label="Descripción"
                                    name="description"
                                    required={true}
                                    rows={5}
                                    touched={formik.touched.description}
                                    errors={formik.errors.description}
                                    value={formik.values.description}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    <StepperButtons
                        onClick={formik.handleSubmit}
                        stepsLength={stepsLength}
                        disabledNext={submit}
                        loading={submit}
                    />
                </>
            ) : (
                <>
                    {duplicated && (
                        <>
                            <Typography
                                variant="h4"
                                justifyContent="center"
                                align="center"
                            >
                                Registro Existente
                            </Typography>
                            <Typography
                                variant="h5"
                                justifyContent="center"
                                align="center"
                                sx={{ mt: 2 }}
                            >
                                Este usuario ya se había comunicado durante el
                                mes en curso y se guardó esta subtipificación.
                                <br></br>
                                Registrarlo de la misma manera constituye una
                                reincidencia y afecta tu indicador.<br></br>
                                Te invitamos a validar otras opciones de
                                tipificación que coincidan con lo informado por
                                el usuario en la transacción.<br></br>
                            </Typography>
                            <StepperButtons
                                onClick={() => maintainTypificacion()}
                                onClickBack={() => closeMaintain()}
                                stepsLength={stepsLength}
                                disabledNext={submit}
                                loading={submit}
                                titleAdd="Mantener tipificación"
                                titleBack="Otra tipificación"
                            />
                        </>
                    )}
                    {maintain && (
                        <>
                            <Box>
                                <Grid
                                    container
                                    spacing={{ xs: 1.5, md: 1.5 }}
                                    columnSpacing={{
                                        xs: 1.5,
                                        sm: 1.5,
                                        md: 1.5,
                                    }}
                                >
                                    <Grid item xs={12} md={6} lg={6}>
                                        <FieldText
                                            label="Usuario Asesor"
                                            name="user"
                                            size="small"
                                            required={true}
                                            disabled
                                            value={usernameLog || ''}
                                            onChange={formik.handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={6}>
                                        <FieldText
                                            label="Nombre Asesor"
                                            name="name"
                                            size="small"
                                            required={true}
                                            disabled
                                            value={
                                                nameLog + ' ' + surnameLog || ''
                                            }
                                            onChange={formik.handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={6}>
                                        <FieldText
                                            label="Documento Asesor"
                                            name="documentAuthorized"
                                            size="small"
                                            required={true}
                                            touched={
                                                formik.touched
                                                    .documentAuthorized
                                            }
                                            errors={
                                                formik.errors.documentAuthorized
                                            }
                                            value={
                                                formik.values.documentAuthorized
                                            }
                                            onChange={formik.handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={6}>
                                        <FieldText
                                            label="Nombre Supervisor"
                                            name="supervisorAuthorized"
                                            size="small"
                                            required={true}
                                            touched={
                                                formik.touched
                                                    .supervisorAuthorized
                                            }
                                            errors={
                                                formik.errors
                                                    .supervisorAuthorized
                                            }
                                            value={
                                                formik.values
                                                    .supervisorAuthorized
                                            }
                                            onChange={formik.handleChange}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                            <StepperButtons
                                onClick={formik.handleSubmit}
                                onClickBack={() => closeMaintain()}
                                stepsLength={stepsLength}
                                disabledNext={submit}
                                loading={submit}
                                titleAdd="Guardar"
                                titleBack="Volver"
                            />
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default Typification;
